module.exports = __webpack_public_path__ + "media/images/image-about-d57fc79515eb5156ce77d7e3e82b12cd.png";